module.exports = __webpack_public_path__ + "images/08-09@2x_eb9fb475.png";